import React from 'react';
import { QuestStatus } from 'src/enums/quests';
import { ActivityHeader } from './styled';

interface Props {
    from: QuestStatus;
    to: QuestStatus;
    user: string;
}

const StatusChangeActivity: React.FC<Props> = ({ from, to, user }) => {
    if (from === QuestStatus.NEW && to === QuestStatus.IN_PROCESS) {
        return (
            <ActivityHeader>
                Request moved from <strong>In queue</strong> to{' '}
                <strong>In progress</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.NEW && to === QuestStatus.ON_HOLD) {
        return (
            <ActivityHeader>
                Request moved from <strong>In queue</strong> to{' '}
                <strong>Backlog</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.ON_HOLD && to === QuestStatus.NEW) {
        return (
            <ActivityHeader>
                Request moved from <strong>Backlog</strong> to{' '}
                <strong>In queue</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.IN_PROCESS && to === QuestStatus.IN_REVIEW) {
        return (
            <ActivityHeader>
                Request moved from <strong>In progress</strong> to{' '}
                <strong>In review</strong>
            </ActivityHeader>
        );
    }
    if (to === QuestStatus.DONE) {
        return <ActivityHeader>Request finished successfully</ActivityHeader>;
    }
    if (from === QuestStatus.IN_REVIEW && to === QuestStatus.IN_PROCESS) {
        return (
            <ActivityHeader>
                Request moved from <strong>In review</strong> to{' '}
                <strong>In progress</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.NEW && to === QuestStatus.IN_REVIEW) {
        return (
            <ActivityHeader>
                Request moved from <strong>In queue</strong> to{' '}
                <strong>In review</strong>{' '}
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.NEW && to === QuestStatus.CANCELLED) {
        return (
            <ActivityHeader>
                {user} rejected the implementation plan and cancelled the
                request
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.IN_PROCESS && to === QuestStatus.ON_HOLD) {
        return (
            <ActivityHeader>
                Request paused by {user} and moved to <strong>Backlog</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.DONE && to === QuestStatus.IN_REVIEW) {
        return (
            <ActivityHeader>
                Request moved from <strong>Done</strong> to{' '}
                <strong>In review</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.ON_HOLD && to === QuestStatus.ARCHIVED) {
        return (
            <ActivityHeader>
                Request moved from <strong>Backlog</strong> to{' '}
                <strong>Archived</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.DONE && to === QuestStatus.ARCHIVED) {
        return (
            <ActivityHeader>
                Request moved from <strong>Done</strong> to{' '}
                <strong>Archived</strong>
            </ActivityHeader>
        );
    }
    if (from === QuestStatus.ARCHIVED && to === QuestStatus.ON_HOLD) {
        return (
            <ActivityHeader>
                Request unarchived by {user} and moved to{' '}
                <strong>Backlog</strong>
            </ActivityHeader>
        );
    }
    return <ActivityHeader />;
};

export default StatusChangeActivity;
